<template>
  <div class="wh-screen">
    <global-confirm-box ref="confirmBox" />
    <warehouse-write-off-dialog
      v-model="writeOffDialog"
      :edited-item="editedItem"
      @groceriesWrittenOff="addDocuments"
      @success="onSuccess"
    />
    <warehouse-doc-screen
      v-bind="docProps"
      :mobile="device.isMobile"
      @update:aggregate="aggregateMode = $event"
      @hint="setFiltersToLastEntry"
      @action="onDocAction"
      @open-row="openRowDoc"
      @toast="$emit('toast', $event)"
    >
      <template #row-actions="{ row }">
        <warehouse-row-button icon="mdi-eye" :label="$t('overview')" tone="pri" action="view" @click="openRowDoc(row)" />
        <warehouse-row-button icon="mdi-trash-can-outline" :label="$t('delete')" tone="danger" action="delete" @click="deleteRowDoc(row)" />
      </template>
      <template #detail-actions="{ row }">
        <warehouse-row-button icon="mdi-eye" :label="$t('overview')" tone="pri" action="view" @click="openRowDoc(row)" />
        <warehouse-row-button icon="mdi-trash-can-outline" :label="$t('delete')" tone="danger" action="delete" @click="deleteRowDoc(row)" />
      </template>
    </warehouse-doc-screen>
  </div>
</template>

<script>
import WarehouseTabWriteOff from "@/components/warehouse/tabs/WarehouseTabWriteOff.vue";
import WarehouseDocScreen from "../../docs/WarehouseDocScreen.vue";
import WarehouseRowButton from "../../docs/WarehouseRowButton.vue";
import hasDocumentListScreen from "../../docs/hasDocumentListScreen";

/**
 * Otpis robe: lista dokumenata ili zbirni prikaz po artiklu, "Otpiši robu" u traci alata. Nasleđuje učitavanje,
 * filtriranje, brisanje, štampu, Excel i dijalog iz starog taba.
 */
export default {
  name: "WarehouseScreenWriteOff",
  extends: WarehouseTabWriteOff,
  mixins: [hasDocumentListScreen],
  components: { WarehouseDocScreen, WarehouseRowButton },
  computed: {
    docConfig() {
      return {
        icon: "mdi-delete-sweep-outline",
        hintKey: "warehouse.last_write_off",
        emptyTitleKey: "no_write_offs",
        emptyTextKey: "no_write_offs_yet",
        dateLabel: this.$t("warehouse.write-off_date"),
        open: "editItem",
        remove: "deleteItem",
        run: "openWriteOffDialog",
        action: { key: "writeoff", label: this.$t("warehouse.write-off-product"), icon: "mdi-trash-can-outline", tone: "danger" },
      };
    },
  },
};
</script>
